import { Action, createReducer, on } from '@ngrx/store';
import { IOtpRequest, IOtpResponse } from '../../../core/models/otp.model';
import { IGenericError, ErrorResponse } from '../../../core/models/generic-models';
import {
  loadLoginConfirmRequest,
  loadLoginConfirmSuccess,
  loadLoginConfirmFailure,
  clearLoginConfirmSuccess
} from '../actions/login-confirm.actions';

export const loginConfirmFeatureKey = 'loginConfirm';

export interface LoginConfirmState {
  isLoading: boolean;
  loadLoginConfirmRequest: IOtpRequest;
  loadLoginConfirmSuccess: IOtpResponse;
  loadLoginConfirmFailure: IGenericError<ErrorResponse>;
}

export const initialState: LoginConfirmState = {
  isLoading: false,
  loadLoginConfirmRequest: undefined,
  loadLoginConfirmSuccess: undefined,
  loadLoginConfirmFailure: undefined
};

export const reducer = createReducer(
  initialState,

  //#region REGISTER
  on(loadLoginConfirmRequest, (state, action) => ({
    ...state,
    loadLoginConfirmRequest: action.request,
    isLoading: true
  })),
  on(loadLoginConfirmSuccess, (state, action) => ({
    ...state,
    loadLoginConfirmSuccess: action.response,
    isLoading: false
  })),
  on(loadLoginConfirmFailure, (state, action) => ({
    ...state,
    loadLoginConfirmFailure: action.error,
    isLoading: false
  })),
  on(clearLoginConfirmSuccess, (state, action) => ({
    ...state,
    loadLoginConfirmSuccess: undefined
  }))

  //#endregion
);

//#region LOGIN
export const getIsLoginConfirmLoading = (state: LoginConfirmState) => state.isLoading;
export const getLoginConfirmRequest = (state: LoginConfirmState) => state.loadLoginConfirmRequest;
export const getLoginConfirmSuccess = (state: LoginConfirmState) => state.loadLoginConfirmSuccess;
export const getLoginConfirmFailure = (state: LoginConfirmState) => state.loadLoginConfirmFailure;
//#endregion
